import React from "react";
import { Zap, ShieldCheck, CreditCard, MessageCircle, Clock, UserCheck } from "lucide-react";

const BENEFITS = [
  { icon: Zap, title: "تنفيذ سريع جدًا", desc: "استلم سيولتك خلال دقائق معدودة من تقديم الطلب.", featured: true },
  { icon: ShieldCheck, title: "سرية وأمان كامل", desc: "بياناتك محمية 100% ولا تتم مشاركتها مع أي طرف ثالث." },
  { icon: CreditCard, title: "بدون إجراءات بنكية", desc: "لا حاجة لتعاملات بنكية معقدة أو أوراق كثيرة." },
  { icon: MessageCircle, title: "دعم مباشر عبر واتساب", desc: "فريقنا متواجد لخدمتك والإجابة على استفساراتك." },
  { icon: Clock, title: "متاح طوال الأسبوع", desc: "خدمتنا متوفرة لك في أي وقت تحتاج فيه إلى السيولة." },
  { icon: UserCheck, title: "للمواطن والمقيم", desc: "خدمتنا متاحة للجميع بنفس السهولة والاحترافية." },
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-20 md:py-28 bg-white relative overflow-hidden" data-testid="benefits-section">
      <div
        className="absolute inset-0 opacity-[0.035] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #0F3D2E 1px, transparent 0)",
          backgroundSize: "28px 28px",
        }}
      />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative">
        <div className="text-center mb-14 fade-up">
          <div className="inline-block text-brand-gold font-bold text-sm tracking-widest uppercase mb-3">
            لماذا ميرال كروب؟
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-brand-green leading-tight">
            مميزات تجعلنا الخيار الأذكى
          </h2>
          <p className="mt-3 text-base md:text-lg text-brand-ink/70 max-w-2xl mx-auto">
            خدمة احترافية مصممة لتمنحك الراحة والثقة في كل خطوة.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                data-testid={`benefit-card-${i + 1}`}
                className={`group relative rounded-3xl p-7 md:p-8 transition-all duration-300 fade-up ${
                  b.featured
                    ? "bg-gradient-to-br from-brand-green to-brand-green-light text-white shadow-2xl ring-1 ring-brand-gold/30 lg:row-span-1 lg:col-span-1"
                    : "bg-brand-bg border border-black/5 hover:shadow-xl hover:-translate-y-1"
                }`}
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <div
                  className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-5 ${
                    b.featured
                      ? "bg-brand-gold/20 ring-1 ring-brand-gold/40"
                      : "bg-white border border-brand-gold/30"
                  }`}
                >
                  <Icon
                    className={`w-7 h-7 ${b.featured ? "text-brand-gold-light" : "text-brand-green"}`}
                  />
                </div>
                <h3
                  className={`font-heading text-xl font-extrabold mb-2 ${
                    b.featured ? "text-white" : "text-brand-green"
                  }`}
                >
                  {b.title}
                </h3>
                <p
                  className={`text-sm md:text-base leading-relaxed ${
                    b.featured ? "text-white/85" : "text-brand-ink/70"
                  }`}
                >
                  {b.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
